export type ProcessEditorTab = 'details' | 'turtle' | 'flow' | 'releases'
export type ProcessDiagramTab = 'turtle' | 'flow'

export function hasTurtleContent(turtleData: any): boolean {
  if (!turtleData || typeof turtleData !== 'object') return false

  return Object.values(turtleData).some((entries) => Array.isArray(entries) && entries.some((entry) => {
    if (typeof entry === 'string') return entry.trim().length > 0
    return typeof entry?.text === 'string' && entry.text.trim().length > 0
  }))
}

export function hasFlowContent(flowData: any): boolean {
  return Array.isArray(flowData?.nodes) && flowData.nodes.length > 0
}

export function processDiagramTabs(process: any): ProcessDiagramTab[] {
  const tabs: ProcessDiagramTab[] = []
  if (hasTurtleContent(process?.turtle_data)) tabs.push('turtle')
  if (hasFlowContent(process?.flow_data)) tabs.push('flow')
  return tabs
}

export function initialProcessDiagramTab(process: any): ProcessDiagramTab | null {
  return processDiagramTabs(process)[0] || null
}

export function visibleProcessTabs(process: any, canEdit: boolean): ProcessEditorTab[] {
  if (canEdit) return ['details', 'turtle', 'flow', 'releases']

  const tabs: ProcessEditorTab[] = ['details']
  tabs.push(...processDiagramTabs(process))
  return tabs
}

export function initialProcessTab(process: any, canEdit: boolean): ProcessEditorTab {
  if (canEdit) return 'details'

  const diagramTabs = visibleProcessTabs(process, false).filter((tab) => tab === 'turtle' || tab === 'flow')
  return diagramTabs.length === 1 ? diagramTabs[0] : 'details'
}
